export interface AuthResult {
  permission?: UserPermission[];
  user?: User;
}

export enum UserRoleType {
  SystemManager = "SystemManager",
  TenantManager = "TenantManager",
  PropertyManager = "PropertyManager",
  PropertyStaff = "PropertyStaff",
  LockerInstaller = "LockerInstaller",
  EntranceInstaller = "EntranceInstaller",
}
/**
 * UserPermission
 */
export interface UserPermission {
  action: string;
  effect: string;
  resource: string;
}

/**
 * User
 */
export interface User {
  company_name?: string;
  email?: string;
  id: string;
  nickname?: string;
  phone_number?: string;
  create_time?: string;
  roles: UserRole[];
  token_device?: string;
}

/**
 * UserRole
 */
export interface UserRole {
  property_id?: string;
  property_name?: string;
  role: string;
  tenant?: string;
}
